import { displayedDetailTypeMap } from '@databases/collab/convert/to-collab';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setDisplayDetail: YJSChangeHandler<
  DatabaseChangeType.SET_DISPLAY_DETAIL
> = ({ ydb, change }) => {
  const convertedDisplayedDetailType =
    displayedDetailTypeMap[change.displayedDetailTypes];

  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];
    field.displayedDetail = convertedDisplayedDetailType;
  });
};
